import { Directive, effect, ElementRef, inject, input, OnDestroy } from '@angular/core';
import { GuideStep } from './guide-step.enum';
import { GuideService } from './guide.service';

@Directive({
  selector: '[appGuideStep]',
})
export class GuideStepDirective implements OnDestroy {
  private readonly _elementRef = inject(ElementRef<HTMLElement>);
  private readonly _guideService = inject(GuideService);

  readonly appGuideStep = input<GuideStep | null>(null);

  constructor() {
    effect(() => {
      const currentStep = this._guideService.currentStep();
      const myStep = this.appGuideStep();

      if (myStep !== null && currentStep === myStep) {
        setTimeout(() => {
          const rect = this._elementRef.nativeElement.getBoundingClientRect();
          this._guideService.setActiveElement(rect);
        }, 0);
      }
    });
  }

  ngOnDestroy(): void {
    const myStep = this.appGuideStep();
    if (myStep !== null && this._guideService.currentStep() === myStep) {
      this._guideService.activeElementRect.set(null);
    }
  }
}
